import React from 'react';

import { Avatar, Space } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import styles from './logo.module.scss';

type TLogoProps = {
  link: string;
  isCard?: boolean;
};

export const Logo = ({ link, isCard = false }: TLogoProps) => {
  const cx = useStyles(styles);

  if (!isCard) {
    return <Avatar size={36} src={link} />;
  }

  return (
    <Space direction="vertical" justify="center" className={cx('cardLogoWrapper')}>
      <img src={link} loading="lazy" alt="" className={cx('cardLogo')} />
    </Space>
  );
};
